import React from 'react'
import { Link } from 'react-router-dom'
import './ComingSoon.component.scss'

const ComingSoon = ({
  headline = 'Coming Soon',
  message = 'Something great is on the way.',
  ctaLabel = 'Get in Touch',
  ctaHref = '/contact',
}) => (
  <section className='coming-soon' aria-label={headline}>
    <div className='coming-soon__container'>
      <div className='coming-soon__icon-wrapper' aria-hidden='true'>
        <i className='fas fa-shield-alt coming-soon__icon' />
      </div>
      <h1 className='coming-soon__headline'>{headline}</h1>
      <p className='coming-soon__message'>{message}</p>
      <Link to={ctaHref} className='coming-soon__cta'>
        {ctaLabel}
      </Link>
    </div>
  </section>
)

export default ComingSoon
